/**
 * CampaignTrackerEmbed - Standalone embeddable page for campaign progress
 * URL: /campaigns/:slug/embed?style=thermometer|donut|bar&color=%2310b981
 */
import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import PledgeProgressTracker from '@/components/PledgeProgressTracker';

const queryClient = new QueryClient();

export default function CampaignTrackerEmbed() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  
  const style = searchParams.get('style') || 'thermometer';
  const color = searchParams.get('color') || '#10b981';
  const compact = searchParams.get('compact') === 'true';
  const showPledges = searchParams.get('pledges') !== 'false';

  return (
    <div className="min-h-screen bg-transparent p-4 flex items-center justify-center">
      <div className="w-full max-w-md">
        <PledgeProgressTracker
          slug={slug}
          style={style}
          color={color}
          compact={compact}
          showPledges={showPledges}
        />
      </div>
    </div>
  );
}
